import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/publish/translation.publishRuns.query.gql"
import type {
  TranslationPublishRunsQuery,
  TranslationPublishRunsQueryVariables,
} from "@/v2-backoffice-client/translation/publish/__types__/translation.publishRuns.query"

type Options = QueryHookOptions<
  TranslationPublishRunsQuery,
  TranslationPublishRunsQueryVariables
>

export function useTranslationPublishRunsQuery(options?: Options) {
  return useQuery<
    TranslationPublishRunsQuery,
    TranslationPublishRunsQueryVariables
  >(query, options)
}
